import React, { useEffect, useState } from 'react';
import { useLoginContext } from '../../../App';
import { useContentContext } from '../../layout/Layout';
import useLogbook from './useLogbook';
import LogbookModal from './LogbookModal';
import { newAreaIndicatorLogbookDTO } from './logbookDTOs'; // Create a file for DTOs
import { fetchAreaIndicatorLogbook } from '../../../services/b2b-logbook-apiServices';
import useAccessControl from '../../b2b-users/hooks/useAccessControl';
import LogbookWhiteList from '../components/whitelist/LogbookWhiteList';
import { AdminPanelSettings } from '@mui/icons-material';
import { AreaIndicatorMainDetails, IndicatorDetails } from '../../b2b-plans/components/area-indicators/AreaIndicatorCard';
import Banner from '../../b2b-common/Banner';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import { Box } from '@mui/material';

const AreaIndicatorLogbookModal = ({ logbookRelatedEntity = null, open, onClose }) => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-logbook');

    const [showHeader, setShowHeader] = useState(true);

    const {
        currentOpen,
        setCurrentOpen,
        currentLogbook,
        setCurrentLogbook,
        currentFolder,
        newLogbookConfirmationRequest,
        setNewLogbookConfirmationRequest,
        logbookDeleteConfirmationRequest,
        setLogbookDeleteConfirmationRequest,
        handleCreateNewLogbook,
        handleUpdatedLogbook,
        handleFolderChange,
        handleDeleteLogbook,
        handleClose,
    } = useLogbook('AREA_INDICATOR', loginData, setNotification, t, onClose, logbookRelatedEntity, newAreaIndicatorLogbookDTO, fetchAreaIndicatorLogbook);

    useEffect(() => {
        if (open && (currentOpen !== open)) {
            setCurrentOpen(true);
        }
    }, [currentOpen, open, setCurrentOpen]);

    const { checkAccess: showWhiteList } = useAccessControl([
        {
            productsRequired: ['B2B_LOGBOOK'],
            rolesRequired: ['ADMIN', 'EDITOR']
        },
    ]);

    const tabsConfig = [
        {
            label: t('Area indicator'),
            icon: null,
            content: (
                <Box width={'100%'}>
                    <AreaIndicatorMainDetails areaIndicatorData={logbookRelatedEntity} />
                    <Banner sectionTittle={t('Indicator used:')} headingLevel='h4' underline={false} />
                    <IndicatorDetails indicator={logbookRelatedEntity.indicatorDTO} />
                </Box>
            ),
            showTab: true,
        },
        {
            label: t('Security whitelist'),
            icon:
                <AdminPanelSettings
                    style={{ color: currentLogbook?.logBookProtected ? '#011d89' : 'grey' }}
                />,
            content: (
                <LogbookWhiteList logbook={currentLogbook} setLogbook={setCurrentLogbook} />
            ),
            showTab: showWhiteList(),
        },
    ];

    return (
        <LogbookModal
            currentOpen={currentOpen}
            currentLogbook={currentLogbook}
            currentFolder={currentFolder}
            newLogbookConfirmationRequest={newLogbookConfirmationRequest}
            logbookDeleteConfirmationRequest={logbookDeleteConfirmationRequest}
            setNewLogbookConfirmationRequest={setNewLogbookConfirmationRequest}
            setLogbookDeleteConfirmationRequest={setLogbookDeleteConfirmationRequest}
            handleCreateNewLogbook={handleCreateNewLogbook}
            handleUpdatedLogbook={handleUpdatedLogbook}
            handleFolderChange={handleFolderChange}
            handleDeleteLogbook={handleDeleteLogbook}
            handleClose={handleClose}
            showHeader={showHeader}
            setShowHeader={setShowHeader}
            tabsConfig={tabsConfig}
            t={t}
            headerTitle={t('Logbook for area indicator:')}
            headerMessage={logbookRelatedEntity?.planName}
        />
    );
};

export default AreaIndicatorLogbookModal;